import { render } from "./QaDetails.vue?vue&type=template&id=126d179c&scoped=true"
import script from "./QaDetails.vue?vue&type=script&lang=js"
export * from "./QaDetails.vue?vue&type=script&lang=js"

import "./QaDetails.vue?vue&type=style&index=0&id=126d179c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-126d179c"]])

export default __exports__